import { render, staticRenderFns } from "./Cracha.vue?vue&type=template&id=4acbc0ad&scoped=true"
import script from "./Cracha.vue?vue&type=script&lang=js"
export * from "./Cracha.vue?vue&type=script&lang=js"
import style0 from "./Cracha.vue?vue&type=style&index=0&id=4acbc0ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acbc0ad",
  null
  
)

export default component.exports